<template>
  <LayoutGradient :content-overflow="false">

    <template #headerRight>
      <b-button variant="outline-primary" @click="getNewTree">Carregar JSON</b-button>
    </template>

    <b-card-group class="m-3 mt-n10" deck>
      <b-card class="col-md-6">
        <form>
          <b-form-file
              placeholder="Escolha arquivo ou Solte aqui"
              drop-placeholder="Solte aqui"
              class="mb-3"
              @change="loadXML"
          />
        </form>
        <VueTreeList
            @click="onClick"
            @change-name="() => {}"
            @delete-node="onDel"
            @add-node="onAdd"
            default-tree-node-name="Array/Objeto"
            default-leaf-node-name="Elemento"
            :model="tree"
            v-bind:default-expanded="false"
        >
          <!--<template v-slot:leafNameDisplay="slotProps">-->
          <template class="icon" slot="addTreeNodeIcon">
            <b-icon icon="folder-plus"/>
          </template>
          <template class="icon" slot="addLeafNodeIcon">
            <b-icon icon="plus"/>
          </template>
          <template class="icon" slot="editNodeIcon">
            <b-icon icon="pencil"/>
          </template>
          <template class="icon" slot="delNodeIcon">
            <b-icon icon="trash"/>
            ️
          </template>
          <template class="icon" slot="leafNodeIcon">
            <b-icon icon="braces"/>
          </template>
          <template class="icon" slot="treeNodeIcon">
            <b-icon icon="archive"/>
          </template>
        </VueTreeList>

        <b-popover v-if="model" :target="popover.target" :show.sync="popover.show" placement="bottom">
          <template #title>
            <div  class="d-flex align-items-center justify-content-between">
              {{ model.name }}
              <b-button @click="clearSelected" class="close ml-2" aria-label="Close">
                <span class="d-inline-block" aria-hidden="true">&times;</span>
              </b-button>
            </div>
          </template>
          <Form :model="model" @update="localUpdateNode" />
        </b-popover>

      </b-card>

      <b-card v-if="newTree">
        <pre>{{ newTree }}</pre>
      </b-card>

    </b-card-group>
  </LayoutGradient>
</template>

<script>
import {Tree, VueTreeList} from 'vue-tree-list'
import LayoutGradient from "@/templates/LayoutGradient";
import Form from "@/pages/Tree/Form";
import GenerateParserClass from '@/pages/Tree/generateParserClass'
import TreeNodeMixins from "@/pages/Tree/TreeNodeMixins";

export default {
  name: "Index",
  components: {Form, LayoutGradient, VueTreeList},
  mixins: [TreeNodeMixins],
  watch: {
    fileJSON(newVal) {
      const jsonParsed = JSON.parse(newVal)

      const _generateNode = (element) => {
        let TreeNode = this.generateNode(element)
        TreeNode.editable = false
        TreeNode.editNodeDisabled = true

        if (
            (!element.elements && !element.attributes) ||
            (element.elements && element.elements.length === 0) ||
            (element.attributes && element.attributes.length === 0)
        ) {
          TreeNode.type = 'Info'
          TreeNode.isLeaf = true
        }

        if (element.elements && element.elements.length > 0) {
          TreeNode.type = 'Array'

          if (element.elements.length === 1) {
            TreeNode.type = 'Object'
          }

          TreeNode.children = element.elements.map(e => {
            return _generateNode({...e, pid: Tree.id})
          })
        }

        if (element.attributes && Object.keys(element.attributes).length > 0) {
          let subAttribute = Object.keys(element.attributes).map(key => {
            return _generateNode({name: key, pid: TreeNode.id, isAttribute: true})
          })
          subAttribute = TreeNode.children ? [...TreeNode.children, ...subAttribute] : subAttribute
          TreeNode.type = 'Object'
          TreeNode.children = subAttribute
        }

        return TreeNode
      }

      this.tree = new Tree(
          jsonParsed.elements.map(_generateNode)
      )
    }
  },
  data() {
    return {
      model: null,
      popover: {
        target: '',
        show: false
      },
      newTree: null,
      fileXML: null,
      fileJSON: null
    }
  },
  methods: {
    async loadXML(evt) {
      const convert = require('xml-js');
      const file = evt.target.files[0]

      const reader = new FileReader()
      reader.onload = (e) => {
        this.fileXML = e.target.result
        this.fileJSON = convert.xml2json(this.fileXML, {spaces: 2})
      }

      reader.readAsText(file)
    },
    onClick(params) {
      if (this.model) {
        this.clearSelected()
      }

      setTimeout(() => {
        this.popover.target = String(params.id)
        this.popover.show = true
        this.model = params
        const el = document.getElementById(this.popover.target)
        el.classList.add(...['bg-gray-300', 'border', 'border-primary', 'rounded'])
      }, 100)
    },
    localUpdateNode(model) {
      this.updateNode(model)
      this.clearSelected()
    },
    clearSelected() {
      const el = document.getElementById(this.model.id)
      el.classList.remove(...['bg-gray-300', 'border', 'border-primary', 'rounded'])
      this.model = null
    },
    getNewTree() {

      function _dfs(oldNode) {
        const exclude = ['id', 'pid', 'children', 'parent', 'isLeaf', 'dragDisabled', 'editable', 'editNodeDisabled', 'delNodeDisabled']
        var newNode = {}

        for (var k in oldNode) {
          if (!exclude.includes(k)) {
            newNode[k] = oldNode[k]
          }
        }

        if (oldNode.children && oldNode.children.length > 0) {
          newNode.children = []
          for (var i = 0, len = oldNode.children.length; i < len; i++) {
            newNode.children.push(_dfs(oldNode.children[i]))
          }
        }
        return newNode
      }

      this.newTree = _dfs(this.tree)

      const generate = new GenerateParserClass('MatrixDiagnosisV7', 'OrderAbstract')
      generate.setJson(this.newTree)
      // console.log(generate.getString())
      generate.generateCreatePatient()
      generate.generateCreateExam()
      generate.generateCreateOrder()
      generate.generateCreateRecipient()
      let stringified = ''
      Object.keys(generate.$mapped).map(key => {
        stringified = stringified + `\n private $${key}Path` + ' = ['

        Object.keys(generate.$mapped[key]).map(subkey => {
          stringified = stringified + `\n '${subkey}' => '${generate.$mapped[key][subkey]}',`
        })

        stringified = stringified + '\n ];'
      })
      this.newTree = stringified
    }
  }
}
</script>

<style lang="scss" scoped>
.vtl {
  ::v-deep.vtl-node {
    .vtl-node-main {
      .vtl-caret {
        margin-right: .25rem !important;

        &:hover {
          cursor: pointer;
        }
      }

      span > svg {
        margin-right: .5rem;
      }
    }
  }
}

.sticky-top {
  top: 1.5rem;
}

::v-deep.float-shadow {
  box-shadow: rgba(50, 50, 93, 0.25) 0 50px 100px -20px, rgba(0, 0, 0, 0.3) 0px 30px 60px -30px, rgba(10, 37, 64, 0.35) 0px -2px 6px 0px inset !important;
}
</style>
